/* Chat Widget for n8n — Shopify Asset build
   Enhanced version with improved typing animation + pre-chat identify (first-time only)
   Portable, config-driven. Paste this file into assets/chat-widget.js
   It expects a small window.ChatWidgetConfig block in theme.liquid.
*/
(function () {
  if (window.N8nChatWidgetLoaded) return;
  window.N8nChatWidgetLoaded = true;

  // ---------- Config ----------
  const defaults = {
    webhook: { url: "", route: "" },
    branding: {
      logo: "",
      name: "Concierge",
      welcomeText: "Welcome! Let's get you to the right place.",
      responseTimeText: "Usually replies in under a minute.",
      poweredBy: { text: "Built by Custom Coding", link: "https://customcoding.com.au" }
    },
    style: {
      loadGoogleFont: false,     // set true to load Poppins
      primaryColor: "#20743B",
      secondaryColor: "#4A5568",
      backgroundColor: "#ffffff",
      fontColor: "#1f2937",
      position: "right",         // "right" | "left"
      glow: "neutral",           // "brand" | "neutral" | "none"
      borderColor: "#e6e6e6",    // subtle borders
      lightColor: "#f0f2f5"      // light fills/scrollbar
    },
    launcherText: "Need help?",
    suggestedQuestions: [],
    persistenceKey: "n8nChatWidget",
    network: { timeoutMs: 20000, maxRetries: 1 },
    typingMinMs: 700,
    // New: pre-chat config (first-time only by default)
    prechat: {
      enabled: true,         // show pre-chat when no stored user
      requireName: true,
      requireEmail: true,
      forceReidentify: false // keep false to only ask on first time (unless storage cleared)
    }
  };

  const cfg = (function merge() {
    const s = window.ChatWidgetConfig || {};
    const style = { ...defaults.style, ...(s.style || {}) };
    // sanitize legacy purple
    if (style.primaryColor === "#854fff") style.primaryColor = "#20743B";
    if (style.secondaryColor === "#6b3fd4") style.secondaryColor = "#4A5568";
    return {
      webhook: { ...defaults.webhook, ...(s.webhook || {}) },
      branding: { ...defaults.branding, ...(s.branding || {}) },
      style,
      launcherText: s.launcherText ?? defaults.launcherText,
      suggestedQuestions: Array.isArray(s.suggestedQuestions) ? s.suggestedQuestions : [],
      persistenceKey: s.persistenceKey || defaults.persistenceKey,
      network: { ...defaults.network, ...(s.network || {}) },
      typingMinMs: typeof s.typingMinMs === 'number' ? s.typingMinMs : defaults.typingMinMs,
      prechat: { ...defaults.prechat, ...(s.prechat || {}) }
    };
  })();

  // ---------- Optional font ----------
  if (cfg.style.loadGoogleFont) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap";
    document.head.appendChild(link);
  }

  // ---------- Styles ----------
  const styles = document.createElement("style");
  styles.textContent = `
  .chat-assist-widget {
    --chat-color-primary: var(--chat-widget-primary, ${cfg.style.primaryColor});
    --chat-color-secondary: var(--chat-widget-secondary, ${cfg.style.secondaryColor});
    --chat-color-tertiary: var(--chat-widget-tertiary, ${cfg.style.secondaryColor});
    --chat-color-light: var(--chat-widget-light, ${cfg.style.lightColor});
    --chat-color-surface: var(--chat-widget-surface, ${cfg.style.backgroundColor});
    --chat-color-text: var(--chat-widget-text, ${cfg.style.fontColor});
    --chat-color-text-light: var(--chat-widget-text-light, #6b7280);
    --chat-color-border: var(--chat-widget-border, ${cfg.style.borderColor});
    --chat-shadow-sm: 0 1px 3px rgba(0,0,0,0.08);
    --chat-shadow-md: 0 4px 10px rgba(0,0,0,0.12);
    --chat-shadow-lg: 0 12px 24px rgba(0,0,0,0.18);
    --chat-radius-sm: 8px;
    --chat-radius-md: 12px;
    --chat-radius-lg: 20px;
    --chat-radius-full: 9999px;
    --chat-transition: all .3s cubic-bezier(.4,0,.2,1);
    font-family: ${cfg.style.loadGoogleFont ? "'Poppins', " : ""}system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  }
  @media (prefers-reduced-motion: reduce) {
    .chat-assist-widget * { transition: none !important; animation: none !important; }
  }
  .chat-assist-widget .chat-window {
    position: fixed; bottom: 90px; z-index: 1000; width: 380px; height: 580px;
    background: var(--chat-color-surface); border-radius: var(--chat-radius-lg);
    box-shadow: var(--chat-shadow-lg); border: 1px solid var(--chat-color-border);
    overflow: hidden; display: none; flex-direction: column; transition: var(--chat-transition);
    opacity: 0; transform: translateY(20px) scale(.95);
  }
  .chat-assist-widget .chat-window.right-side { right: 20px; }
  .chat-assist-widget .chat-window.left-side  { left: 20px; }
  .chat-assist-widget .chat-window.visible { display: flex; opacity: 1; transform: translateY(0) scale(1); }

  .chat-assist-widget .chat-header {
    padding: 16px; display: flex; align-items: center; gap: 12px;
    background: linear-gradient(135deg, var(--chat-color-primary) 0%, var(--chat-color-secondary) 100%);
    color: #fff; position: relative;
  }
  .chat-assist-widget .chat-header-logo {
    width: 32px; height: 32px; border-radius: var(--chat-radius-sm); object-fit: contain; background: #fff; padding: 4px;
  }
  .chat-assist-widget .chat-header-title { font-size: 16px; font-weight: 600; color: #fff; }
  .chat-assist-widget .chat-close-btn {
    position: absolute; right: 16px; top: 50%; transform: translateY(-50%);
    background: rgba(255,255,255,.2); border: none; color: #fff; cursor: pointer; padding: 4px;
    display: flex; align-items: center; justify-content: center; transition: var(--chat-transition);
    font-size: 18px; border-radius: var(--chat-radius-full); width: 28px; height: 28px;
  }
  .chat-assist-widget .chat-close-btn:hover { background: rgba(255,255,255,.3); transform: translateY(-50%) scale(1.1); }

  .chat-assist-widget .chat-welcome { position:absolute; inset:0; display:grid; place-items:center; padding:24px; text-align:center; }
  .chat-assist-widget .chat-welcome-title { font-size:22px; font-weight:700; color:var(--chat-color-text); margin-bottom:24px; line-height:1.3; }
  .chat-assist-widget .chat-start-btn {
    display:flex; align-items:center; justify-content:center; gap:10px; width:100%;
    padding:14px 20px; background: linear-gradient(135deg, var(--chat-color-primary) 0%, var(--chat-color-secondary) 100%);
    color:#fff; border:none; border-radius: var(--chat-radius-md); cursor:pointer; font-size:15px;
    transition: var(--chat-transition); font-weight:600; margin-bottom:16px; box-shadow: var(--chat-shadow-md);
  }
  .chat-assist-widget .chat-start-btn:hover { transform: translateY(-2px); box-shadow: var(--chat-shadow-lg); }
  .chat-assist-widget .chat-response-time { font-size:14px; color:var(--chat-color-text-light); margin:0; }

  .chat-assist-widget .chat-body { display:none; flex-direction:column; height:100%; min-height:0; }
  .chat-assist-widget .chat-body.active { display:flex; }
  .chat-assist-widget .chat-messages {
    flex:1 1 auto; min-height:0; overflow-y:auto; padding:20px; background:#f9fafb; display:flex; flex-direction:column; gap:12px;
  }
  .chat-assist-widget .chat-messages::-webkit-scrollbar { width:6px; }
  .chat-assist-widget .chat-messages::-webkit-scrollbar-thumb { background-color: rgba(0,0,0,.2); border-radius: var(--chat-radius-full); }

  .chat-assist-widget .chat-bubble {
    padding:14px 18px; border-radius: var(--chat-radius-md); max-width:85%; word-wrap:break-word;
    font-size:14px; line-height:1.6; position:relative; white-space:pre-line;
  }
  .chat-assist-widget .chat-bubble.user-bubble {
    background: linear-gradient(135deg, var(--chat-color-primary) 0%, var(--chat-color-secondary) 100%);
    color:#fff; align-self:flex-end; border-bottom-right-radius:4px; box-shadow: var(--chat-shadow-sm);
  }
  .chat-assist-widget .chat-bubble.bot-bubble {
    background:#fff; color:var(--chat-color-text); align-self:flex-start; border-bottom-left-radius:4px;
    box-shadow: var(--chat-shadow-sm); border:1px solid var(--chat-color-border);
  }

  /* Enhanced typing indicator with text and animated dots */
  .chat-assist-widget .typing-indicator {
    display:flex; align-items:center; gap:10px;
    padding:12px 16px; background:#fff; border:1px solid var(--chat-color-border);
    border-radius: var(--chat-radius-md); border-bottom-left-radius:4px;
    align-self:flex-start; box-shadow: var(--chat-shadow-sm);
    animation: slideInFade 0.3s ease forwards;
  }
  .chat-assist-widget .typing-text {
    font-size: 13px;
    color: var(--chat-color-text-light);
    font-weight: 500;
    font-style: italic;
  }
  .chat-assist-widget .typing-dots-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .chat-assist-widget .typing-dot {
    width:8px; height:8px; border-radius:9999px;
    background: var(--chat-color-primary);
    animation: typingBounce 1.4s infinite ease-in-out;
  }
  .chat-assist-widget .typing-dot:nth-child(1){ animation-delay: 0s; }
  .chat-assist-widget .typing-dot:nth-child(2){ animation-delay: 0.2s; }
  .chat-assist-widget .typing-dot:nth-child(3){ animation-delay: 0.4s; }

  @keyframes typingBounce {
    0%, 60%, 100% { transform: translateY(0) scale(1); opacity: 0.7; }
    30% { transform: translateY(-8px) scale(1.1); opacity: 1; }
  }
  @keyframes slideInFade { 
    from { opacity:0; transform: translateX(-10px) scale(.96); } 
    to   { opacity:1; transform: translateX(0) scale(1); } 
  }

  .chat-assist-widget .chat-controls {
    position: sticky; padding:16px; background: var(--chat-color-surface); border-top:1px solid var(--chat-color-border);
    display:flex; gap:10px; box-sizing: border-box;
  }
  .chat-assist-widget .chat-textarea {
    flex:1; padding:14px 16px; border:1px solid var(--chat-color-border); border-radius: var(--chat-radius-md);
    background: var(--chat-color-surface); color: var(--chat-color-text); resize:none; font-size:14px; line-height:1.5;
    max-height:120px; min-height:48px; transition: var(--chat-transition);
  }
  .chat-assist-widget .chat-textarea:focus { outline:none; border-color:var(--chat-color-primary); box-shadow:0 0 0 3px rgba(59,130,246,0.25); }
  .chat-assist-widget .chat-submit {
    background: linear-gradient(135deg, var(--chat-color-primary) 0%, var(--chat-color-secondary) 100%);
    color:#fff; border:none; border-radius: var(--chat-radius-md); width:48px; height:48px; cursor:pointer;
    transition: var(--chat-transition); display:flex; align-items:center; justify-content:center; flex-shrink:0; box-shadow: var(--chat-shadow-sm);
  }
  .chat-assist-widget .chat-submit:hover { transform: scale(1.05); box-shadow: var(--chat-shadow-md); }

  .chat-assist-widget .chat-launcher {
    position: fixed; bottom: 20px; height: 56px; border-radius: var(--chat-radius-full);
    background: linear-gradient(135deg, var(--chat-color-primary) 0%, var(--chat-color-secondary) 100%);
    color:#fff; border:none; cursor:pointer; box-shadow: var(--chat-shadow-md); z-index:999; transition: var(--chat-transition);
    display:flex; align-items:center; padding:0 20px 0 16px; gap:8px;
  }
  .chat-assist-widget .chat-launcher.right-side { right: 20px; }
  .chat-assist-widget .chat-launcher.left-side  { left: 20px; }
  .chat-assist-widget .chat-launcher:hover { transform: scale(1.05); box-shadow: var(--chat-shadow-lg); }
  .chat-assist-widget .chat-launcher-text { font-weight:600; font-size:15px; white-space:nowrap; }

  .chat-assist-widget .chat-footer { padding:10px; text-align:center; background: var(--chat-color-surface); border-top:1px solid var(--chat-color-border); }
  .chat-assist-widget .chat-footer-link { color: var(--chat-color-primary); text-decoration:none; font-size:12px; opacity:.8; transition: var(--chat-transition); }
  .chat-assist-widget .chat-footer-link:hover { opacity:1; }

  .chat-assist-widget .suggested-questions { display:flex; flex-direction:column; gap:8px; margin:12px 0; align-self:flex-start; max-width:85%; }
  .chat-assist-widget .suggested-question-btn {
    background:#f3f4f6; border:1px solid var(--chat-color-border); border-radius: var(--chat-radius-md); padding:10px 14px;
    text-align:left; font-size:13px; color:var(--chat-color-text); cursor:pointer; transition: var(--chat-transition); line-height:1.4;
  }
  .chat-assist-widget .suggested-question-btn:hover { background: var(--chat-color-light); border-color: var(--chat-color-primary); }

  .chat-assist-widget .user-registration { position:absolute; inset:0; display:none; place-items:center; padding:24px; text-align:center; }
  .chat-assist-widget .user-registration.active { display:grid; }
  .chat-assist-widget .registration-title { font-size:18px; font-weight:600; color:var(--chat-color-text); margin-bottom:16px; line-height:1.3; }
  .chat-assist-widget .form-field { display:flex; flex-direction:column; gap:4px; text-align:left; }
  .chat-assist-widget .form-label { font-size:14px; font-weight:500; color:var(--chat-color-text); }
  .chat-assist-widget .form-field + .form-field { margin-top: 16px;}
  .chat-assist-widget .form-input { padding:12px 14px; border:1px solid var(--chat-color-border); border-radius: var(--chat-radius-md); font-size:14px; }
  .chat-assist-widget .form-input:focus { outline:none; border-color:var(--chat-color-primary); box-shadow:0 0 0 3px rgba(59,130,246,0.25); }
  .chat-assist-widget .form-input.error { border-color:#ef4444; }
  .chat-assist-widget .error-text { font-size:12px; color:#ef4444; margin-top:2px; }
  .chat-assist-widget .submit-registration {
    display:flex; align-items:center; justify-content:center; width:100%; padding:14px 20px; margin-top:20px;
    background: linear-gradient(135deg, var(--chat-color-primary) 0%, var(--chat-color-secondary) 100%);
    color:#fff; border:none; border-radius: var(--chat-radius-md); cursor:pointer; font-size:15px; font-weight:600; box-shadow: var(--chat-shadow-md);
  }
  .chat-assist-widget .submit-registration:hover { transform: translateY(-2px); box-shadow: var(--chat-shadow-lg); }
  .chat-assist-widget .submit-registration:disabled { opacity:.7; cursor:not-allowed; transform:none; }
  `;
  document.head.appendChild(styles);

  // ---------- Root + theme ----------
  const root = document.createElement("div");
  root.className = "chat-assist-widget";
  root.style.setProperty("--chat-widget-primary", cfg.style.primaryColor);
  root.style.setProperty("--chat-widget-secondary", cfg.style.secondaryColor);
  root.style.setProperty("--chat-widget-tertiary", cfg.style.secondaryColor);
  root.style.setProperty("--chat-widget-surface", cfg.style.backgroundColor);
  root.style.setProperty("--chat-widget-text", cfg.style.fontColor);
  root.style.setProperty("--chat-widget-border", cfg.style.borderColor);
  root.style.setProperty("--chat-widget-light", cfg.style.lightColor);

  // shadow/glow theme
  const SHADOWS = {
    brand:   ['0 1px 3px rgba(116, 108, 32,0.10)','0 4px 10px rgba(116, 108, 32,0.15)','0 12px 24px rgba(116, 108, 32, 0.2)'],
    neutral: ['0 1px 3px rgba(0,0,0,0.08)','0 4px 10px rgba(0,0,0,0.12)','0 12px 24px rgba(0,0,0,0.18)'],
    none:    ['none','none','none']
  }[cfg.style.glow || "neutral"];
  root.style.setProperty('--chat-shadow-sm', SHADOWS[0]);
  root.style.setProperty('--chat-shadow-md', SHADOWS[1]);
  root.style.setProperty('--chat-shadow-lg', SHADOWS[2]);

  // ---------- DOM ----------
  const chatWindow = document.createElement("div");
  chatWindow.className = `chat-window ${cfg.style.position === "left" ? "left-side" : "right-side"}`;
  chatWindow.innerHTML = `
    <div class="chat-header" role="banner">
      <img class="chat-header-logo" src="${cfg.branding.logo}" alt="${cfg.branding.name}">
      <span class="chat-header-title">${cfg.branding.name}</span>
      <button class="chat-close-btn" aria-label="Close chat">×</button>
    </div>
    <div class="chat-welcome">
      <div>
        <h2 class="chat-welcome-title">${cfg.branding.welcomeText}</h2>
        <button class="chat-start-btn" type="button" aria-haspopup="dialog">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          Start chatting
        </button>
        <p class="chat-response-time">${cfg.branding.responseTimeText}</p>
      </div>
    </div>
    <div class="user-registration">
      <div>
        <h2 class="registration-title">Please enter your details to start chatting</h2>
        <form class="registration-form">
          <div class="form-field">
            <label class="form-label" for="chat-user-name">Name</label>
            <input type="text" id="chat-user-name" class="form-input" placeholder="Your name" required>
            <div class="error-text" id="name-error"></div>
          </div>
          <div class="form-field">
            <label class="form-label" for="chat-user-email">Email</label>
            <input type="email" id="chat-user-email" class="form-input" placeholder="Your email address" required>
            <div class="error-text" id="email-error"></div>
          </div>
          <button type="submit" class="submit-registration">Continue to Chat</button>
        </form>
      </div>
    </div>
    <div class="chat-body" role="dialog" aria-label="Chat dialog" aria-live="polite">
      <div class="chat-messages"></div>
      <div class="chat-controls">
        <textarea class="chat-textarea" placeholder="Type your message here..." rows="1"></textarea>
        <button class="chat-submit" type="button" aria-label="Send message">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"></path><path d="M22 2l-7 20-4-9-9-4 20-7z"></path></svg>
        </button>
      </div>
      <div class="chat-footer">
        <a class="chat-footer-link" href="${cfg.branding.poweredBy.link}" target="_blank" rel="noopener">${cfg.branding.poweredBy.text}</a>
      </div>
    </div>
  `;

  const launcher = document.createElement("button");
  launcher.className = `chat-launcher ${cfg.style.position === "left" ? "left-side" : "right-side"}`;
  launcher.setAttribute("type", "button");
  launcher.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
    <span class="chat-launcher-text">${cfg.launcherText}</span>
  `;

  root.appendChild(chatWindow);
  root.appendChild(launcher);
  document.body.appendChild(root);

  // ---------- Refs ----------
  const startBtn   = chatWindow.querySelector(".chat-start-btn");
  const chatBody   = chatWindow.querySelector(".chat-body");
  const messages   = chatWindow.querySelector(".chat-messages");
  const textarea   = chatWindow.querySelector(".chat-textarea");
  const sendBtn    = chatWindow.querySelector(".chat-submit");
  const regForm    = chatWindow.querySelector(".registration-form");
  const regPane    = chatWindow.querySelector(".user-registration");
  const welcomePane= chatWindow.querySelector(".chat-welcome");
  const nameInput  = chatWindow.querySelector("#chat-user-name");
  const emailInput = chatWindow.querySelector("#chat-user-email");
  const nameErr    = chatWindow.querySelector("#name-error");
  const emailErr   = chatWindow.querySelector("#email-error");

  // ---------- Helpers ----------
  const persist = {
    load() { try { return JSON.parse(localStorage.getItem(cfg.persistenceKey) || "{}"); } catch { return {}; } },
    save(o) { localStorage.setItem(cfg.persistenceKey, JSON.stringify(o || {})); }
  };
  function createId(){ return (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36)+Math.random().toString(36).slice(2,8)); }
  function linkify(t){
    if (typeof t !== "string") return "";
    const url=/(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
    return t.replace(url,u=>`<a href="${u}" target="_blank" rel="noopener noreferrer" class="chat-link">${u}</a>`);
  }
  function createTyping(){
    const el=document.createElement("div");
    el.className="typing-indicator";
    el.innerHTML=`
      <span class="typing-text">Milo is typing...</span>
      <div class="typing-dots-wrapper">
        <div class="typing-dot"></div>
        <div class="typing-dot"></div>
        <div class="typing-dot"></div>
      </div>
    `;
    return el;
  }
  function addBot(text){ const el=document.createElement("div"); el.className="chat-bubble bot-bubble"; el.innerHTML=linkify(text); messages.appendChild(el); }
  function addUser(text){ const el=document.createElement("div"); el.className="chat-bubble user-bubble"; el.textContent=text; messages.appendChild(el); }
  
  function scrollToNewMessage() {
    const chat = document.querySelector(".chat-messages");
    if (!chat) return;

    // Find the last bot message
    const bots = chat.querySelectorAll(".bot-bubble");
    const lastBot = bots[bots.length - 1];
    if (!lastBot) return;

    // Scroll so the top of the last bot message is visible
    chat.scrollTo({
      top: lastBot.offsetTop - 10, // small padding
      behavior: "smooth"
    });
  }
  
  function autoResize(){ textarea.style.height="auto"; textarea.style.height=Math.min(120, textarea.scrollHeight) + "px"; }
  function wait(ms){ return new Promise(r=>setTimeout(r, ms)); }
  async function ensureMinDelay(startMs, minMs){ const elapsed=Date.now()-startMs; if(elapsed<minMs) await wait(minMs - elapsed); }

  async function postJSON(payload, retries = 1, delayMs = 800) {
    if (!cfg.webhook?.url) throw new Error("Webhook URL missing");

    try {
      const res = await fetch(cfg.webhook.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) return await res.json();
      return await res.text();

    } catch (err) {
      if (retries > 0) {
        console.warn("Retrying concierge request...", err.message);
        await new Promise(r => setTimeout(r, delayMs));
        return await postJSON(payload, retries - 1, delayMs);
      }
      throw err;
    }
  }

  // New: send identify event (no hardcoding; uses cfg.webhook)
  async function sendIdentify({ sessionId, name, email }) {
    const payload = {
      action: "identify",
      sessionId,
      route: cfg.webhook.route,
      name, email,
      metadata: { userId: email || "", userName: name || "" }
    };
    try {
      await postJSON(payload);  // single object, not [payload]
    } catch (e) {
      console.warn("identify failed (continuing):", e);
    }
  }

  // ---------- Session ----------
  let isWaiting=false;
  let conversationId="";
  let userName="";
  let userEmail="";

  // First-time only pre-chat behavior
  (function loadSession(){
    const s = persist.load();
    const hasStoredUser = Boolean(s && s.userEmail);

    if (cfg.prechat.enabled) {
      const canReuse = !cfg.prechat.forceReidentify && hasStoredUser;
      if (canReuse) {
        conversationId = s.conversationId || createId();
        userName = s.userName || "";
        userEmail = s.userEmail || "";
        welcomePane.style.display = "none";
        regPane.classList.remove("active");
        chatBody.classList.add("active");
      } else {
        // show Start screen; pre-chat will appear when user clicks
        welcomePane.style.display = "grid";
        regPane.classList.remove("active");
        chatBody.classList.remove("active");
      }
    } else {
      // Pre-chat disabled: jump to chat immediately
      conversationId = (s && s.conversationId) || createId();
      userName = (s && s.userName) || "";
      userEmail = (s && s.userEmail) || "";
      welcomePane.style.display = "none";
      regPane.classList.remove("active");
      chatBody.classList.add("active");
    }
  })();

  function saveSession(){ persist.save({conversationId,userName,userEmail}); }
  function showRegistration(){
    welcomePane.style.display="none";
    regPane.classList.add("active");
    setTimeout(()=>nameInput?.focus(), 50);
  }
  function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  async function handleRegistration(e){
    e.preventDefault();
    nameErr.textContent=""; emailErr.textContent="";
    nameInput.classList.remove("error"); emailInput.classList.remove("error");

    const n=nameInput.value.trim();
    const m=emailInput.value.trim();
    let ok=true;
    if(cfg.prechat.requireName && !n){ nameErr.textContent="Please enter your name"; nameInput.classList.add("error"); ok=false; }
    if(cfg.prechat.requireEmail && !m){ emailErr.textContent="Please enter your email"; emailInput.classList.add("error"); ok=false; }
    else if(cfg.prechat.requireEmail && !validEmail(m)){ emailErr.textContent="Please enter a valid email address"; emailInput.classList.add("error"); ok=false; }
    if(!ok) return;

    conversationId=createId(); userName=n; userEmail=m; saveSession();
    regPane.classList.remove("active"); chatBody.classList.add("active");

    const typing=createTyping(); messages.appendChild(typing); //scrollToNewMessage();
    const start=Date.now();

    try {
      // Intro bubble
      addBot("Thank you. Calling your Concierge…");
      // scrollToNewMessage();

      // 1) Identify (quiet if slow/fails)
      try {
        await sendIdentify({ sessionId: conversationId, name: userName, email: userEmail });
      } catch (e) {
        console.warn("identify failed (continuing):", e);
      }

      // 2) Optional preload (quiet if slow/fails)
      try {
        const preload = {
          action: "loadPreviousSession",
          sessionId: conversationId,
          route: cfg.webhook.route,
          metadata: { userId: userEmail || "", userName: userName || "" }
        };
        await postJSON(preload);        // NOTE: single object, not array
      } catch (e) {
        console.warn("preload failed (continuing):", e);
      }

      // 3) Kick off the AI welcome
      const infoMsg = {
        action: "sendMessage",
        sessionId: conversationId,
        route: cfg.webhook.route,
        chatInput: `INIT_WELCOME\nName: ${userName}\nEmail: ${userEmail}`,
        metadata: { userId: userEmail, userName, isUserInfo: true }
      };

      const res = await postJSON(infoMsg);
      await ensureMinDelay(start, cfg.typingMinMs);
      try { messages.removeChild(typing); } catch {}

      const text = Array.isArray(res) ? res[0]?.output : (res && res.output);
      addBot(text || "You are connected. How can I help?");

      if (cfg.suggestedQuestions.length) {
        const wrap = document.createElement("div");
        wrap.className = "suggested-questions";
        cfg.suggestedQuestions.forEach(q => {
          const b = document.createElement("button");
          b.className = "suggested-question-btn";
          b.textContent = q;
          b.addEventListener("click", () => submitMessage(q));
          wrap.appendChild(b);
        });
        messages.appendChild(wrap);
      }

      // scrollToNewMessage();

    } 
    
    catch (err) {
      console.error("Registration error:", err);
      try { messages.removeChild(typing); } 
        catch {}
        // Important: do NOT show the failure bubble here anymore
    }
  }

  async function submitMessage(text){
    if(!text || isWaiting) return;
    if(!conversationId){ conversationId=createId(); saveSession(); }
    isWaiting=true;
    addUser(text);
    const typing=createTyping(); messages.appendChild(typing); //scrollToNewMessage();
    const start=Date.now();

    // Correct order: name/email mapped consistently
    const payload={
      action:"sendMessage",
      sessionId:conversationId,
      route:cfg.webhook.route,
      chatInput:text,
      name: userName || "",
      email: userEmail || "",
      metadata:{ userId:userEmail||"", userName:userName||"" }
    };

    try{
      const res=await postJSON(payload);
      await ensureMinDelay(start, cfg.typingMinMs);
      messages.removeChild(typing);
      const responseText=Array.isArray(res)? res[0]?.output : (res && res.output);
      addBot(responseText || "No response received.");
      // scrollToNewMessage();
    }catch(err){
      console.error("Message error:", err);
      await ensureMinDelay(start, cfg.typingMinMs);
      try { messages.removeChild(typing); } catch {}
      addBot("Sorry, I couldn't send your message. Please try again.");
      // scrollToNewMessage();
    }finally{
      isWaiting=false;
    }
  }

  // ---------- Events ----------
  startBtn.addEventListener("click", showRegistration);
  regForm.addEventListener("submit", handleRegistration);

  sendBtn.addEventListener("click", () => {
    const t=textarea.value.trim();
    if(t && !isWaiting){ submitMessage(t); textarea.value=""; autoResize(); }
  });
  textarea.addEventListener("input", autoResize);
  textarea.addEventListener("keypress", e=>{
    if(e.key==="Enter" && !e.shiftKey){
      e.preventDefault();
      const t=textarea.value.trim();
      if(t && !isWaiting){ submitMessage(t); textarea.value=""; autoResize(); }
    }
  });

  (document.querySelector('.chat-launcher') || root.querySelector('.chat-launcher')).addEventListener("click", () => {
    const visible=chatWindow.classList.toggle("visible");
    if(visible) setTimeout(()=>startBtn?.focus(), 50);
  });
  chatWindow.querySelectorAll(".chat-close-btn").forEach(b=> b.addEventListener("click", ()=> chatWindow.classList.remove("visible")));

  // ---------- Mount ----------
  document.body.appendChild(root);
})();
